import { render, staticRenderFns } from "./LetterChoiceModal.vue?vue&type=template&id=66fce62b&scoped=true"
import script from "./LetterChoiceModal.vue?vue&type=script&lang=js"
export * from "./LetterChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./LetterChoiceModal.vue?vue&type=style&index=0&id=66fce62b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fce62b",
  null
  
)

export default component.exports